export const regexPatterns = Object.freeze({
  email: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}/,
  lowerCase: /(?=.*[a-z])/,
  upperCase: /(?=.*[A-Z])/,
  isNumber: /(?=.*[0-9])/,
  isSpecial: /(?=.*[.!@#$%^&*])/,
  passwordLength: /(?=.{11,})/,
})
